<template>
  <a-icon
      v-if="condition"
      type="filter"
      theme="filled"
  />
  <a-icon
      v-else
      style="color: #005baa"
      type="filter"
      theme="filled"
  />
</template>

<script>
export default {
  name: "FilterIcon",
  props: ['condition']
}
</script>
